import React from "react";

const AboutText = () => {
  return (
    <section className=" text-baseBlue">
      <div className="max-w-5xl mx-auto text-center">
        <div className="px-4 sm:px-10 animate-fade-in-up delay-300">
          <h1 className="text-3xl sm:text-4xl font-semibold mb-6">
            AWC Garejelebi - Where Champions Are Made{" "}
          </h1>
          <div className="flex flex-col gap-4 leading-relaxed mb-6">
            <p>
              Founded in 2016 by Mamuka Bilanishvili, AWC Garejelebi started
              with just a single table and no equipment. But with hard work,
              dedication, and a passion for armwrestling, we grew—adding
              equipment, expanding our gym, and welcoming a growing number of
              talented athletes.
            </p>{" "}
            <p>
              Our journey to success began with Giorgi Dighmelashvili, the first
              athlete to train at our gym. He later became our first World
              Champion, marking the start of a legacy. By 2018, we were already
              dominating the national championships, winning in several
              categories. Just a year later, in 2019, we proudly became the
              number one armwrestling team in Georgia, earning medals at both
              European and World Championships—a title we've held ever since.
            </p>
            <p>
              Today, our team continues to break records, winning more medals at
              European and World Championships than many entire nations. But we
              didn't stop there. Our athletes have taken on the biggest stages,
              including the prestigious "East vs. West" event. Bacho
              Saginashvili and Nugzar Chikadze proudly represent us, and we’re
              eagerly awaiting championship belts from them in the near future.
            </p>
            <p>
              What’s the secret to our success? It’s not genetics, as some might
              think. It’s knowledge, discipline, and proper training. Too many
              armwrestlers make mistakes with bad techniques and poor training,
              which limits their success. At our club, we’ve already trained 15
              European and World Champions, and we’re just getting started.
            </p>
            <p>
              If you dream of success in armwrestling, join us at AWC
              Garejelebi. Train under the guidance of our legendary coach,
              Mamuka Bilanishvili, and take your place among the champions.
            </p>
          </div>
        </div>
        <p className="text-lg sm:text-xl font-medium mb-6 animate-fade-in-up delay-100">
          <strong className="">
            Welcome to AWC Garejelebi Online – Your Gateway to Arm Wrestling
            Mastery
          </strong>
        </p>

        {/* Why Choose Our Online Courses */}
        <div className="p-6 sm:p-10 rounded-2xl mb-8 animate-fade-in-up delay-300">
          <h2 className="text-2xl sm:text-3xl font-semibold mb-6">
            Why Train with Us?
          </h2>
          <ul className="space-y-4 text-left">
            {[
              {
                title: "Learn from the Best",
                description:
                  "Train under coach Mamuka, one of the most respected names in arm wrestling.",
              },
              {
                title: "Structured Training",
                description:
                  "Follow a step-by-step curriculum designed for beginners and advanced athletes alike.",
              },
              {
                title: "Train Anytime, Anywhere",
                description:
                  "Access lessons at your convenience and fit training into your schedule.",
              },
              {
                title: "Supportive Community",
                description:
                  "Join a global network of athletes who share your passion and drive.",
              },
              {
                title: "Exclusive Insights",
                description:
                  "Gain insider tips, competition strategies, and mental training techniques.",
              },
            ].map((item, index) => (
              <li key={index} className="flex items-start">
                <span className=" text-2xl mr-3">•</span>
                <strong>{item.title}:</strong> {item.description}
              </li>
            ))}
          </ul>
        </div>
        {/* What You'll Gain */}
        <div className=" p-6 sm:p-10 rounded-2xl mb-8 animate-fade-in-up delay-400">
          <h2 className="text-2xl sm:text-3xl font-semibold  mb-6">
            What You'll Gain
          </h2>
          <p className="leading-relaxed mb-6">
            Our courses provide an all-encompassing approach to arm wrestling
            mastery. Whether you're a beginner or an advanced athlete, you'll
            gain:
          </p>
          <ul className="space-y-4 text-left">
            {[
              "Enhanced strength and technique",
              "Insider tips from top competitors",
              "Mental toughness for competitions",
              "Deep understanding of rules and strategies",
            ].map((item, index) => (
              <li key={index} className="flex items-start">
                <span className=" text-2xl mr-3">•</span>
                {item}.
              </li>
            ))}
          </ul>
        </div>

        {/* Our Vision */}
        <div className="p-6 sm:p-10 rounded-2xl mb-8 animate-fade-in-up delay-500">
          <h2 className="text-2xl sm:text-3xl font-semibold  mb-6">
            Our Vision
          </h2>
          <p className="leading-relaxed">
            Arm wrestling is more than just a sport – it’s a lifestyle. We aim
            to make world-class training accessible to everyone, creating a
            global community dedicated to excellence and growth.
          </p>
        </div>

        {/* Join Us Today */}
        <div className="p-6 sm:p-10 rounded-2xl animate-fade-in-up delay-600">
          <h2 className="text-2xl sm:text-3xl font-semibold  mb-6">
            Join Us Today
          </h2>
          <p className="leading-relaxed">
            Take the first step towards achieving your arm wrestling dreams.
            Whether you're starting out or aiming to compete at the highest
            level, our courses will guide you to success.
          </p>
        </div>

        <p className=" font-bold text-xl sm:text-2xl mt-10 animate-fade-in-up delay-700">
          AWC Garejelebi – The Harmony of Power and Spirit
        </p>
      </div>
    </section>
  );
};

export default AboutText;
